import { Spacing } from '@persona-id/design-tokens';
import styled from 'styled-components';

import Card from 'design-system/components/Card/Card';

export const StyledMetricsCard = styled(Card)`
  position: relative;
  min-width: 720px;
  font-family: ${({ theme }) => theme.text.fontFamily.base};
`;

export const SummaryCardBody = styled(Card.Body)`
  padding-top: ${Spacing[1]};
  padding-left: ${Spacing[5]};
  padding-right: ${Spacing[5]};
  padding-bottom: 0px;
  grid-gap: 0px;
`;

export const SectionTitle = styled(Card.Title)`
  min-height: ${Spacing[7]};
`;
